"use client";

import { useMediaQuery } from "./useMediaQuery";

/**
 * Detect whether the viewport is below `breakpoint`. Defaults to 1024 px so
 * "mobile" matches anything narrower than the desktop breakpoint used across
 * the design system.
 */
const useIsMobile = (breakpoint: number = 1024): boolean =>
  useMediaQuery(`(max-width: ${breakpoint - 1}px)`);

export default useIsMobile;
